import { Clipboard } from '@angular/cdk/clipboard';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconSize } from '../../core-data-model/IconSize';
import { IconType } from '../../core-data-model/IconType';
import { AsyncDecorator } from '../../core-utilities/AsyncDecorator';
import { TranslationService } from '../../translations/Translation.service';

@Component({
    selector: 'copy-link-button',
    template: `
        <button
            (click)="onClick($event)"
            class="button button-sm"
            [ngClass]="getButtonClass()"
            tooltip-on-click
            [tooltipContent]="linkCopied"
            tooltipPlacement="bottom"
            [tooltipShow]="showLinkCopied"
            [disabled]="disabled"
        >
            <abstract-icon
                [iconType]="IconType.ChainLink"
                [iconSize]="IconSize.Small"
            >
            </abstract-icon>
            {{ getButtonText() }}
        </button>
        <tooltip-content #linkCopied>
            <div class="link-copied">
                {{ copiedToolTipText }}
            </div>
        </tooltip-content>
    `,
    styles: [
        `
            .link-copied {
                width: 84px;
                height: 28px;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                line-height: 1.85;
            }
        `
    ],
    standalone: false
})
export class CopyLinkButtonComponent {
    @Output()
    buttonClicked = new EventEmitter();

    @Input()
    buttonText: string;

    @Input()
    copiedItem: string;

    @Input()
    copiedToolTipText: string;

    @Input()
    isPrimaryButtonStyle = false;

    @Input()
    disabled = false;

    IconType = IconType;
    IconSize = IconSize;
    showLinkCopied = false;

    constructor(
        public TR: TranslationService,
        private clipboard: Clipboard
    ) {}

    @AsyncDecorator.temporaryMark(function (
        this: CopyLinkButtonComponent,
        value: boolean
    ) {
        this.showLinkCopied = value;
    }, 2000)
    async onClick(event: Event) {
        this.showLinkCopied = true;
        event.stopPropagation();
        event.preventDefault();
        this.clipboard.copy(this.copiedItem);
        this.buttonClicked.emit('$event');
    }

    getButtonClass(): string {
        return this.isPrimaryButtonStyle
            ? 'button-primary'
            : 'button-secondary';
    }

    getButtonText(): string {
        return this.buttonText
            ? this.buttonText
            : this.TR.key('assess.people_openinvitation_copylinks');
    }
}
